import type { LegendListAction, MapLegendItem } from "./legend.types"
export const LEGEND_SET_ITEMS: string = "LEGEND_SET_ITEMS"

export function legendSetItem(mapId: string, items: MapLegendItem[]): LegendListAction {
  return { type: LEGEND_SET_ITEMS, mapId, payload: items }
}
